import { Card } from '@betterment/samba-react';
import { useFeatureFlag } from '@betterment/shared-components';

import { AccountOverviewCTAs } from './AccountOverviewCTAs';

import { ImpersonationModalProvider } from '../../../contexts/ImpersonationModalContext';

export const AccountOverviewMenuCard = () => {
  const { enabled: hasDetailsFlagEnabled } = useFeatureFlag({
    splitName: 'retail.b4a_ax_adi_account_details_q4_2025_enabled',
    context: 'AccountOverviewMenuCard',
  });

  if (!hasDetailsFlagEnabled) {
    return null;
  }

  return (
    <Card
      css={{
        color: 'text',
        textStyle: 'text100',
        width: '100%',
        p: 'space.300',
      }}
    >
      <Card.Content>
        <ImpersonationModalProvider>
          <AccountOverviewCTAs />
        </ImpersonationModalProvider>
      </Card.Content>
    </Card>
  );
};
